'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { trackEvent } from './posthog';
import { EVENTS } from './events';

const THRESHOLDS = [25, 50, 75, 100];

export function useScrollDepth(pageName) {
  const pathname = usePathname();
  const firedRef = useRef(new Set());

  useEffect(() => {
    firedRef.current = new Set();

    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;

      const scrollPercent = Math.round((window.scrollY / scrollHeight) * 100);

      for (const threshold of THRESHOLDS) {
        if (scrollPercent >= threshold && !firedRef.current.has(threshold)) {
          firedRef.current.add(threshold);
          trackEvent(EVENTS.ENGAGEMENT_SCROLL_DEPTH, {
            page_name: pageName,
            depth_percent: threshold,
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname, pageName]);
}
